<template>
  <div class="card light-back max-content-width w-100">
    <div class="card-body">
      <div class="small-box">
        <div class="step-title">3. {{$t("Tellija andmed")}}</div>
        <div class="help-block">{{$t("Sisesta tellija andmed")}}</div>

        <Form 
          :validate-on-mount="false"
          :validate-on-input="false"
          :validate-on-change="false"
          @submit="goNext"
        >
          <!-- TYPE -->
          <div class="form-group">
            <label>{{$t("Maksja tuup")}} *</label>
            <Field
              as="select"
              name="type"
              class="form-control"
              v-model="formData.type"
              rules="required"
            >
              <option value="person">{{$t("Eraisik")}}</option>
              <option value="company">{{$t("Juriidiline isik")}}</option>
            </Field>
            <ErrorMessage name="type" class="text-danger small" />
          </div>

          <!-- NAME -->
          <div class="form-group">
            <label>{{$t("Nimi")}} *</label>
            <Field
              name="name"
              rules="required"
              v-model="formData.name"
              class="form-control"
            />
            <ErrorMessage name="name" class="text-danger small" />
          </div>

          <!-- REG CODE -->
          <div class="form-group" v-if="formData.type === 'company'">
            <label>{{$t("Registrikood")}} *</label>
            <Field
              name="reg_code"
              rules="required|numeric"
              v-model="formData.reg_code"
              class="form-control"
            />
            <ErrorMessage name="reg_code" class="text-danger small" />
          </div>

          <!-- PHONE -->
          <div class="form-group">
            <label>{{$t("Telefoninumber")}} *</label>
            <Field
              name="phone"
              rules="required|numeric"
              v-model="formData.phone"
              class="form-control"
            />
            <ErrorMessage name="phone" class="text-danger small" />
          </div>

          <!-- EMAIL -->
          <div class="form-group">
            <label>{{$t("E posti aadress")}} *</label>
            <Field
              name="email"
              rules="required|email"
              v-model="formData.email"
              type="email"
              class="form-control"
            />
            <ErrorMessage name="email" class="text-danger small" />
          </div>

          <br>

          <button :disabled="store.isLoading" class="btn btn-primary btn-block">
            <MoveForwardButton />
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import { useMainStore } from '../includes/store';
import MoveForwardButton from './MoveForwardButton.vue';
import { Form, Field, ErrorMessage } from 'vee-validate';

const store = useMainStore();

const formData = reactive({
  type: "person",
  name: "",
  reg_code: "",
  phone: "",
  email: "",
  want_mail: false
});

const loadState = () => {
  const client = store.stepInfo.client;

  formData.type = client.type;
  formData.name = client.name;
  formData.reg_code = client.reg_code;
  formData.phone = client.phone;
  formData.email = client.email;
  formData.want_mail = client.want_mail;
}

  loadState();

const goNext = () => {
  changeStep("adContent");
}

const saveState = async () => {
  const postData = {
    type: formData.type,
    name: formData.name,
    reg_code: formData.reg_code,
    phone: formData.phone,
    email: formData.email,
    want_mail: formData.want_mail
  };

  store.setIsLoading(true);
  store.setClient(postData);

  await axios.post("/state/client", { state: postData }).catch(() => {
    store.sessExpired();
  });

  store.setIsLoading(false);
}

const changeStep = async (step) => {
  await saveState();
  store.changeStep(step);
}

</script>
